import {ActorId, DeploymentEnvironment} from '@service-and-repairs/awpintegrationlib';
import {IEnvironment} from '../app/interfaces/IEnvironment';

/**
 * Configuration for the DEV_TEST environment (awp-test.bmwgroup.com).
 * Replaces environment.ts if the Angular build configuration 'DEV_TEST' is used.
 */
export const environment: IEnvironment = {
  deploymentEnvironment: DeploymentEnvironment.DEV_TEST,
  hub: 'EMEA',
  alphaRealmEnabled: true,
  softPlanningPreviewEnabled: true,
  navigationItems: [
    {
      titleResource: 'apps.search',
      icon: 'search',
      webComponentUrls: {
        b2d: 'https://air-services-b2d-int-wen-oidc.bmwgroup.com/ui/static/cars-pair-app-frontend/main.js',
        b2dIntranet: 'https://air-services-b2d-int-wen-oidc.bmwgroup.com/ui/static/cars-pair-app-frontend/main.js'
      },
      webComponentCustomTag: 'cars-pair-app',
      hideCaseBar: false,
      serviceCaseRequired: true,
      routingPath: 'search'
    },
    {
      titleResource: 'categories.serviceCases',
      apps: [
        {
          titleResource: 'apps.caseOverview',
          icon: 'list',
          webComponentUrls: {
            b2d: '/ui/service-case/main.mjs',
            b2dIntranet: '/ui/service-case/main.mjs'
          },
          webComponentCustomTag: 'ueg-awp-service-case-overview',
          hideCaseBar: true,
          routingPath: 'caseoverview'
        },
        {
          titleResource: 'apps.caseDetails',
          icon: 'todo',
          webComponentUrls: {
            b2d: '/ui/service-case/main.mjs',
            b2dIntranet: '/ui/service-case/main.mjs'
          },
          webComponentCustomTag: 'ueg-awp-service-case-details',
          routingPath: 'casedetails',
          serviceCaseRequired: true,
          additionalSources: {
            b2d: [
              'https://www.awp-service-case-storage-dev.aws.bmw.cloud/ds-ui/main.js',
              'https://ckf-qa.bmwgroup.com/ui/service-history/main.js',
              '/api/gui/leads/cockpit/main.mjs'
            ],
            b2dIntranet: [
              'https://www.awp-service-case-storage-dev.aws.bmw.cloud/ds-ui/main.js',
              'https://ckf-qa.bmwgroup.net/ui/service-history/main.js',
              '/api/gui/leads/cockpit/main.mjs'
            ]
          }
        }
      ]
    },
    {
      titleResource: 'categories.vehicle',
      apps: [
        {
          titleResource: 'apps.vehicleDetails',
          icon: 'car',
          webComponentUrls: {
            b2d: 'https://air-services-b2d-int-wen-oidc.bmwgroup.com/ui/static/cars-vehicle-details-frontend/main.js',
            b2dIntranet: 'https://air-services-b2d-int-wen-oidc.bmwgroup.com/ui/static/cars-vehicle-details-frontend/main.js'
          },
          webComponentCustomTag: 'cars-vehicle-details',
          routingPath: 'vehicledetails',
          vehicleRequired: true
        },
        {
          titleResource: 'apps.history',
          icon: 'history',
          webComponentUrls: {
            b2d: 'https://air-services-b2d-qa2-wen-oidc.bmwgroup.com/ui/vehicle-history/main.js',
            b2dIntranet: 'https://air-services-internal-qa2.bmwgroup.net/ui/vehicle-history/main.js'
          },
          b2dRoles: ['awp_b2d_vehiclehistory'],
          webComponentCustomTag: 'air-vehicle-history',
          routingPath: 'vehiclehistory',
          vinLongRequired: true
        },
        {
          titleResource: 'apps.diagnosticProtocols',
          icon: 'repeat',
          webComponentUrls: {
            b2d: 'https://www.awp-ista-dev.aws.bmw.cloud/vsm-ui/main.js',
            b2dIntranet: 'https://www.awp-ista-dev.aws.bmw.cloud/vsm-ui/main.js'
          },
          b2dRoles: ['awp_b2d_diagnosticprotocols'],
          webComponentCustomTag: 'vehicle-session-viewer',
          routingPath: 'diagnosticprotocols',
          vinLongRequired: true
        },
        {
          titleResource: 'RITA',
          icon: 'rita',
          iFrameUrls: {
            b2d: 'https://www.rita.azure.bmw.cloud/dev/0.0.0?domain=internet',
            b2dIntranet: 'https://www.rita.azure.bmw.cloud/dev/0.0.0?domain=intranet'
          },
          b2dRoles: [
            'mywosh_access_b2d',
            'mywosh_vehicle_write_b2d'
          ],
          routingPath: 'rita',
          vinShortRequired: true
        },
        {
          titleResource: 'ConnectedDrive Dealer Mode',
          icon: 'rss',
          webComponentUrls: {
            b2d: 'https://kong-public-gateway.e2e.bpc.api.orbit.eu-central-1.connected.bmw/dealer-mode/frontend/v1/main.js',
            b2dIntranet: 'https://kong-public-gateway.e2e.bpc.api.orbit.eu-central-1.connected.bmw/dealer-mode/frontend/v1/main.js'
          },
          b2dRoles: ['awp_b2d_dealercockpit'],
          marketRoles: [
            's_gate_de_user_',
            's_gate_nl_user_',
            's_gate_at_user_',
            's_gate_it_user_',
            's_gate_be_user_',
            's_gate_fr_user_',
            's_gate_es_user_',
            's_gate_pt_user_'
          ],
          webComponentCustomTag: 'dealer-mode-widget',
          routingPath: 'dealermode',
          hideCaseBar: true
        }
      ]
    },
    {
      titleResource: 'categories.leadandcustomer',
      apps: [
        {
          titleResource: 'apps.servicepreparation',
          icon: 'edit_line',
          webComponentUrls: {
            b2d: 'https://sparc-int.aws.bmw.cloud/sparc-serviceprep-3/sparc-service-prep-wrapper-v3.js',
            b2dIntranet: 'https://sparc-int.aws.bmw.cloud/sparc-serviceprep-3/sparc-service-prep-wrapper-v3.js'
          },
          webComponentCustomTag: 'sparc-service-prep',
          b2dRoles: ['awp_b2d_servicepreparation'],
          routingPath: 'servicepreparation',
          vinLongRequired: true
        },
        {
          titleResource: 'apps.fleet',
          icon: 'service_leads',
          webComponentUrls: {
            b2d: '/api/gui/leads/cockpit/main.mjs',
            b2dIntranet: '/api/gui/leads/cockpit/main.mjs'
          },
          additionalSources: {
            b2d: [
              'https://cdf-test.rspretailcrm.com/main.js' // Customer Data Frontend
            ],
            b2dIntranet: [
              'https://cdf-test.ext.eu-central-1.aws.cloud.bmw/main.js'
            ]
          },
          webComponentCustomTag: 'leads-cockpit-fleet',
          b2dRoles: ['awp_b2d_customerfleet'],
          routingPath: 'serviceleads',
          hideCaseBar: true
        },
        {
          titleResource: 'apps.multifleet',
          icon: 'service_leads',
          webComponentUrls: {
            b2d: '/api/gui/leads/cockpit/main.mjs',
            b2dIntranet: '/api/gui/leads/cockpit/main.mjs'
          },
          webComponentCustomTag: 'leads-cockpit-multi-outlet-fleet',
          b2dRoles: ['awp_b2d_multi_outlet_lead_overview'],
          routingPath: 'multiserviceleads',
          hideCaseBar: true
        },
        {
          titleResource: 'apps.potentiallist',
          icon: 'create_potential',
          webComponentUrls: {
            b2d: '/ui/potentials/main.mjs',
            b2dIntranet: '/ui/potentials/main.mjs'
          },
          webComponentCustomTag: 'calm-potentials-list',
          routingPath: 'potentiallist',
          hideCaseBar: true,
          marketConfigurationFeature: 'potentialManagement'
        },
        {
          titleResource: 'apps.servicedemand',
          icon: 'service_requirements',
          webComponentUrls: {
            b2d: '/api/gui/leads/cockpit/main.mjs',
            b2dIntranet: '/api/gui/leads/cockpit/main.mjs'
          },
          additionalSources: {
            b2d: [
              '/ui/live-diagnosis-component/main.mjs',
              '/ui/tyre-service-component/main.mjs',
              '/ui/battery-health-component/main.mjs',
              'https://air-services-b2d-qa2-wen-oidc.bmwgroup.com/ui/qdm/main.js',
              'https://ckf-int.bmwgroup.com/ui/cbs-planning/main.js',
              'https://ckf-int.bmwgroup.com/ui/check-control-messages/main.js',
              'https://cute-apps-dev.aws.bmw.cloud/service-contracts/main.js',
              'https://ckf-int.bmwgroup.com/wc/remote-key-read/request/main.js',
              'https://ckf-int.bmwgroup.com/ui/fault-codes/main.js',
              'https://air-services-b2d-qa2-wen-oidc.bmwgroup.com/ui/measure/sel/main.js',
              'https://air-services-b2d-qa2-wen-oidc.bmwgroup.com/ui/measure/service-bulletin/details/main.js',
              'https://ckf-int.bmwgroup.com/ui/mileage/main.js',
              'https://dealercockpit2-e2e.bmwgroup.com/tsdc/web-components/digital-key/non-prod/current/main.js',
              'https://dealercockpit2-e2e.bmwgroup.com/tsdc/web-components/remote-software-update/non-prod/current/main.js',
              'https://dealercockpit2-e2e.bmwgroup.com/tsdc/web-components/booked-and-bookable/non-prod/current/main.js',
              'https://air-services-b2d-int-wen-oidc.bmwgroup.com/ui/static/cars-service-contracts-frontend/main.mjs',
              'https://cdf-test.rspretailcrm.com/main.js' // Customer Data Frontend
            ],
            b2dIntranet: [
              '/ui/live-diagnosis-component/main.mjs',
              '/ui/tyre-service-component/main.mjs',
              '/ui/battery-health-component/main.mjs',
              'https://air-services-internal-qa2.bmwgroup.net/ui/qdm/main.js',
              'https://ckf-int.bmwgroup.net/ui/cbs-planning/main.js',
              'https://ckf-int.bmwgroup.net/ui/check-control-messages/main.js',
              'https://internal.cute-apps-dev.eu-central-1.aws.cloud.bmw/service-contracts/main.js',
              'https://ckf-int.bmwgroup.net/wc/remote-key-read/request/main.js',
              'https://ckf-int.bmwgroup.net/ui/fault-codes/main.js',
              'https://air-services-internal-qa2.bmwgroup.net/ui/measure/sel/main.js',
              'https://air-services-internal-qa2.bmwgroup.net/ui/measure/service-bulletin/details/main.js',
              'https://ckf-int.bmwgroup.net/ui/mileage/main.js',
              'https://dealercockpit2-e2e.bmwgroup.net/tsdc/web-components/digital-key/non-prod/current/main.js',
              'https://dealercockpit2-e2e.bmwgroup.net/tsdc/web-components/remote-software-update/non-prod/current/main.js',
              'https://dealercockpit2-e2e.bmwgroup.net/tsdc/web-components/booked-and-bookable/non-prod/current/main.js',
              'https://air-services-b2d-int-wen-oidc.bmwgroup.com/ui/static/cars-service-contracts-frontend/main.mjs',
              'https://cdf-test.ext.eu-central-1.aws.cloud.bmw/main.js'
            ]
          },
          webComponentCustomTag: 'leads-cockpit-vehicle',
          b2dRoles: ['awp_b2d_leads'],
          routingPath: 'servicedemand',
          vinLongRequired: true
        },
        {
          titleResource: 'apps.dealerCockpit',
          icon: 'store',
          iFrameUrls: {
            b2d: 'https://dealercockpit2-e2e.bmwgroup.com/tsdc/pages/vehicle-information.xhtml',
            b2dIntranet: 'https://dealercockpit2-e2e.bmwgroup.net/tsdc/pages/vehicle-information.xhtml'
          },
          b2dRoles: ['awp_b2d_dealercockpit'],
          routingPath: 'dealercockpit'
        },
        {
          titleResource: 'CCR reporting',
          icon: 'calendar_car',
          webComponentUrls: {
            b2d: 'https://dealercockpit2-e2e.bmwgroup.com/tsdc/web-components/ccr-reporting/non-prod/current/main.js',
            b2dIntranet: 'https://dealercockpit2-e2e.bmwgroup.net/tsdc/web-components/ccr-reporting/non-prod/current/main.js'
          },
          b2dRoles: [
            'cddc_ccr_retail',
            'cddc_ccr_service',
            'cddc_ccr_carpark',
            'cddc_ccr_market_nsc',
            'cddc_ccr_market_subsidiary'
          ],
          routingPath: 'ccrreporting',
          webComponentCustomTag: 'wc-ccr-reporting',
          hideCaseBar: true
        },
        {
          titleResource: 'CCR Car Park',
          icon: 'calendar_car',
          webComponentUrls: {
            b2dIntranet: 'https://dealercockpit2-e2e.bmwgroup.net/tsdc/web-components/ccr-car-park/non-prod/current/main.js'
          },
          b2dRoles: ['cddc_ccr_carpark'],
          routingPath: 'ccrcarpark',
          webComponentCustomTag: 'we-ccr-carpark',
          hideCaseBar: true
        },
        {
          titleResource: 'Dealer Dashboard',
          icon: 'dashboard',
          webComponentUrls: {
            b2d: 'https://dash-ui.awp-ba-dev.aws.bmw.cloud/main.js',
            b2dIntranet: 'https://dash-ui.awp-ba-dev.aws.bmw.cloud/main.js'
          },
          b2dRoles: ['awp_b2d_dealer_dashboard'],
          webComponentCustomTag: 'core-dashboard-ui',
          routingPath: 'dealerdashboard',
          hideCaseBar: true
        },
        {
          titleResource: 'Dealer Checklist',
          icon: 'list_checked',
          webComponentUrls: {
            b2d: 'https://cute-apps-dev.aws.bmw.cloud/dcl-ui/main.js',
            b2dIntranet: 'https://cute-apps-dev.aws.bmw.cloud/dcl-ui/main.js'
          },
          webComponentCustomTag: 'app-dealer-checklist',
          routingPath: 'dealerchecklist',
          vinLongRequired: true,
          marketConfigurationFeature: 'dealerChecklist'
        }
      ]
    },
    {
      titleResource: 'categories.parts',
      apps: [
        {
          titleResource: 'apps.etk',
          icon: 'etk',
          iFrameUrls: {
            b2d: 'https://etk-cloud-eu-int.bmwgroup.com',
            b2dIntranet: 'https://etk-cloud-eu-int.bmwgroup.net'
          },
          b2dRoles: ['awp_b2d_etk'],
          routingPath: 'etk',
          actorId: ActorId.PARTS_CATALOGUE,
          serviceCaseRequired: true
        },
        {
          titleResource: 'apps.partsCatalog',
          icon: 'etk',
          webComponentUrls: {
            b2d: 'https://catalog-research-int.aws.bmw.cloud/ui/static/parts-catalog/main.js',
            b2dIntranet: 'https://catalog-research-int.eu-central-1.aws.cloud.bmw/ui/static/parts-catalog/main.js'
          },
          routingPath: 'partssearch',
          webComponentCustomTag: 'cars-parts-catalog',
          serviceCaseRequired: true
        },
        {
          titleResource: 'apps.partsUsage',
          icon: 'table_search',
          webComponentUrls: {
            b2d: 'https://catalog-research-int.aws.bmw.cloud/ui/static/parts-usage/main.js',
            b2dIntranet: 'https://catalog-research-int.eu-central-1.aws.cloud.bmw/ui/static/parts-usage/main.js'
          },
          routingPath: 'partsusage',
          webComponentCustomTag: 'cars-parts-usage',
          hideCaseBar: true
        },
        {
          titleResource: 'apps.partsInterpretation',
          icon: 'node_tree',
          webComponentUrls: {
            b2d: 'https://catalog-research-int.aws.bmw.cloud/ui/static/parts-interpretation/main.js',
            b2dIntranet: 'https://catalog-research-int.eu-central-1.aws.cloud.bmw/ui/static/parts-interpretation/main.js'
          },
          routingPath: 'partsinterpretation',
          b2dRoles: ['awp_b2d_parts_pilot', 'awp_b2d_parts_catalog'],
          webComponentCustomTag: 'cars-parts-interpretation',
          hideCaseBar: true
        },
        {
          titleResource: 'apps.partsOrderList',
          icon: 'warehouse',
          webComponentUrls: {
            b2d: '/ui/service-case/main.mjs',
            b2dIntranet: '/ui/service-case/main.mjs'
          },
          webComponentCustomTag: 'service-case-parts-order',
          b2dRoles: ['awp_b2d_etk', 'awp_b2d_parts_pilot', 'awp_b2d_parts_catalog'],
          hideCaseBar: true,
          routingPath: 'partsorderlist'
        },
        {
          titleResource: 'apps.partsOrdering',
          icon: 'shopping_cart',
          iFrameUrls: {
            b2d: 'https://parts-ordering.opus-test.bmwgroup.com',
            b2dIntranet: 'https://parts-ordering.opus-test.bmwgroup.com'
          },
          routingPath: 'partsordering',
          b2dRoles: [
            'OPUS_Ordering',
            'OPUS_Admin',
            'OPUS_Market_Administration'
          ],
          hideCaseBar: true
        },
        {
          titleResource: 'apps.orderOverview',
          icon: 'box_closed',
          iFrameUrls: {
            b2d: 'https://order-overview.opus-test.bmwgroup.com',
            b2dIntranet: 'https://order-overview.opus-test.bmwgroup.com'
          },
          routingPath: 'orderoverview',
          b2dRoles: [
            'OPUS_Order_Overview',
            'OPUS_Admin',
            'OPUS_Market_Administration'
          ],
          hideCaseBar: true
        },
        {
          titleResource: 'apps.partsInfo',
          icon: 'parts_info',
          iFrameUrls: {
            b2d: 'https://parts-info.opus-test.bmwgroup.com',
            b2dIntranet: 'https://parts-info.opus-test.bmwgroup.com'
          },
          routingPath: 'partsinfo',
          b2dRoles: [
            'OPUS_Parts_Info',
            'OPUS_Admin',
            'OPUS_Market_Administration'
          ],
          hideCaseBar: true
        },
        {
          titleResource: 'apps.partsOrderDocuments',
          icon: 'version',
          iFrameUrls: {
            b2d: 'https://documents.opus-test.bmwgroup.com/',
            b2dIntranet: 'https://documents.opus-test.bmwgroup.com/'
          },
          routingPath: 'partsorderdocuments',
          b2dRoles: [
            'OPUS_Documents',
            'OPUS_Admin',
            'OPUS_Market_Administration'
          ],
          hideCaseBar: true
        },
        {
          titleResource: 'apps.promotionOrdering',
          icon: 'calendar_car',
          iFrameUrls: {
            b2d: 'https://promotion-ordering.opus-test.bmwgroup.com',
            b2dIntranet: 'https://promotion-ordering.opus-test.bmwgroup.com'
          },
          routingPath: 'promotionordering',
          b2dRoles: [
            'OPUS_Promotion_Ordering',
            'OPUS_Admin',
            'OPUS_Market_Administration'
          ],
          hideCaseBar: true
        },
        {
          titleResource: 'apps.rtkCreation',
          icon: 'rtk_creation',
          iFrameUrls: {
            b2d: 'https://rtk-creation.opus-test.bmwgroup.com',
            b2dIntranet: 'https://rtk-creation.opus-test.bmwgroup.com'
          },
          routingPath: 'rtkcreation',
          b2dRoles: [
            'OPUS_RTK_Creation',
            'OPUS_Admin',
            'OPUS_Market_Administration'
          ],
          hideCaseBar: true
        },
        {
          titleResource: 'apps.rtkOverview',
          icon: 'bring_forward',
          iFrameUrls: {
            b2d: 'https://rtk-overview.opus-test.bmwgroup.com',
            b2dIntranet: 'https://rtk-overview.opus-test.bmwgroup.com'
          },
          routingPath: 'rtkoverview',
          b2dRoles: [
            'OPUS_RTK_Overview',
            'OPUS_Admin',
            'OPUS_Market_Administration'
          ],
          hideCaseBar: true
        }
      ]
    },
    {
      titleResource: 'categories.serviceInformation',
      apps: [
        {
          titleResource: 'apps.air',
          icon: 'air',
          iFrameUrls: {
            b2d: 'https://myair-b2d-qa2.bmwgroup.com/awp-fork.html',
            b2dIntranet: 'https://myair-b2d-qa2.bmwgroup.net/awp-fork.html'
          },
          b2dRoles: ['awp_b2d_air', 'awp_b2d_air_mot'],
          routingPath: 'air',
          actorId: ActorId.INFORMATION_RESEARCH
        },
        {
          titleResource: 'apps.printCenter',
          icon: 'printer',
          webComponentUrls: {
            b2d: 'https://pdp-ui.awp-print-dev.aws.bmw.cloud/main.js',
            b2dIntranet: 'https://pdp-ui.awp-print-dev.aws.bmw.cloud/main.js'
          },
          b2dRoles: ['awp_b2d_printcenter'],
          webComponentCustomTag: 'print-data-provider',
          routingPath: 'printcenter',
          vinLongRequired: true
        },
        {
          titleResource: 'apps.flatrateSearch',
          icon: 'manual_work',
          webComponentUrls: {
            b2d: 'https://air-services-b2d-qa2-wen-oidc.bmwgroup.com/ui/flatrate-research/main.js',
            b2dIntranet: 'https://air-services-internal-qa2.bmwgroup.net/ui/flatrate-research/main.js'
          },
          b2dRoles: ['awp_b2d_flaterateunits'],
          webComponentCustomTag: 'air-flatrate-powersearch',
          routingPath: 'flatratesearch',
          vinLongRequired: true
        },
        {
          titleResource: 'apps.wvi',
          icon: 'wvi',
          iFrameUrls: {
            b2d: 'https://warrweb.warrapps-t.aws.bmw.cloud/warranty/jsp/VI/ShowVIData.jsp',
            b2dIntranet: 'https://warrweb.warrapps-t.eu-central-1.aws.cloud.bmw/warranty/jsp/VI/ShowVIData.jsp'
          },
          marketRoles: ['s_gate_us_user_'],
          routingPath: 'wvi',
          vinLongRequired: true
        },
        {
          titleResource: 'VCS 2',
          icon: 'construction',
          iFrameUrls: {
            b2d: 'https://bmwus--fullsb.sandbox.my.site.com/VCS2/services/auth/sso/BMWSalesforceOIDC',
            b2dIntranet: 'https://bmwus--fullsb.sandbox.my.site.com/VCS2/services/auth/sso/BMWSalesforceOIDC'
          },
          routingPath: 'vcs',
          vinLongRequired: true
        },
        {
          titleResource: 'TOROS',
          icon: 'toros',
          iFrameUrls: {
            b2d: 'https://concesionarios-es.bmwgroup.com/toros/Search/Get',
            b2dIntranet: 'https://concesionarios-es.bmwgroup.net/toros/Search/Get'
          },
          webAgentSecuredPopupUrls: {
            b2d: 'https://concesionarios-es.bmwgroup.com/WENWebAgentLogin.html'
          },
          routingPath: 'toros',
          b2dRoles: ['es_b2b_srv_attendant', 'es_b2b_srv_advisor'],
          vinLongRequired: true
        },
        {
          titleResource: 'Neumáticos',
          icon: 'tire',
          iFrameUrls: {
            b2d: 'https://concesionarios-es.bmwgroup.com/tyres',
            b2dIntranet: 'https://concesionarios-es.bmwgroup.net/tyres'
          },
          webAgentSecuredPopupUrls: {
            b2d: 'https://concesionarios-es.bmwgroup.com/WENWebAgentLogin.html'
          },
          routingPath: 'neumaticos',
          b2dRoles: ['es_b2b_srv_attendant', 'es_b2b_srv_advisor']
        },
        {
          titleResource: 'SPT iframe',
          icon: 'tire',
          iFrameUrls: {
            b2d: 'https://int.salesportaltires.com/login/s-gate/',
            b2dIntranet: 'https://int.salesportaltires.com/login/s-gate/'
          },
          routingPath: 'sptiframe',
          b2dRoles: [
            'spt_user',
            'spt_admin',
            'spt_order_creator',
            'spt_superuser',
            'spt_quote_admin',
            'spt_quote_creator',
            'spt_quote_user',
            'spt_availability_viewer'
          ]
        },
        {
          titleResource: 'apps.salesPortalTires',
          icon: 'tire',
          webComponentUrls: {
            b2d: 'https://cute-apps-dev.aws.bmw.cloud/spt-ui/main.js',
            b2dIntranet: 'https://cute-apps-dev.aws.bmw.cloud/spt-ui/main.js'
          },
          webComponentCustomTag: 'spt-ui',
          routingPath: 'spt',
          serviceCaseRequired: true,
          vinLongRequired: true,
          b2dRoles: [
            'spt_user',
            'spt_admin',
            'spt_order_creator',
            'spt_superuser',
            'spt_quote_admin',
            'spt_quote_creator',
            'spt_quote_user',
            'spt_availability_viewer'
          ],
          marketConfigurationFeature: 'salesPortalTires'
        }
      ]
    },
    {
      titleResource: 'categories.damages',
      apps: [
        {
          titleResource: 'apps.proNet',
          icon: 'external_link',
          webComponentUrls: {
            b2d: 'https://cute-apps-dev.aws.bmw.cloud/pcs-ui/main.js',
            b2dIntranet: 'https://cute-apps-dev.aws.bmw.cloud/pcs-ui/main.js'
          },
          webComponentCustomTag: 'pcs-ui',
          marketRoles: ['s_gate_de_user_'],
          routingPath: 'pronet',
          vinLongRequired: true
        },
        {
          titleResource: 'apps.damageMarker',
          icon: 'feedback',
          webComponentUrls: {
            b2d: 'https://cute-apps-dev.aws.bmw.cloud/dm-ui/main.js',
            b2dIntranet: 'https://cute-apps-dev.aws.bmw.cloud/dm-ui/main.js'
          },
          webComponentCustomTag: 'app-damage-markers',
          routingPath: 'damagemarker',
          vinLongRequired: true,
          marketConfigurationFeature: 'damageMarkers'
        }
      ]
    },
    {
      titleResource: 'categories.support',
      apps: [
        {
          titleResource: 'apps.feedback',
          icon: 'thumb_up',
          webComponentUrls: {
            b2d: '/ui/feedback/main.mjs',
            b2dIntranet: '/ui/feedback/main.mjs'
          },
          webComponentCustomTag: 'ueg-awp-feedback-frontend',
          routingPath: 'feedback',
          hideCaseBar: true
        },
        {
          titleResource: 'apps.ispiCockpit',
          icon: 'user',
          iFrameUrls: {
            b2d: 'https://ispi-cockpit-test.bmwgroup.com/ispi-cockpit',
            b2dIntranet: 'https://ispi-cockpit-test.bmwgroup.net/ispi-cockpit'
          },
          b2dRoles: [
            'ilean_admin_user',
            'ilean_as_leo_admin_user',
            'ilean_as_leo_admin_admin_inis',
            'ilean_as_leo_user',
            'ispi_compass_user'
          ],
          routingPath: 'ispicockpit',
          hideCaseBar: true
        },
        {
          titleResource: 'apps.feedbackAdmin',
          icon: 'calendar_car',
          webComponentUrls: {
            b2dIntranet: '/api/gui/feedbackadmin/main.mjs'
          },
          webComponentCustomTag: 'ueg-awp-feedback-admin-frontend',
          routingPath: 'feedbackadmin',
          hideCaseBar: true,
          b2dRoles: ['awp_b2d_feedback_viewer']
        },
        {
          titleResource: 'apps.marketConfiguration',
          icon: 'table_settings',
          webComponentUrls: {
            b2d: '/ui/leads/config/main.mjs',
            b2dIntranet: '/ui/leads/config/main.mjs'
          },
          webComponentCustomTag: 'leads-config-market',
          routingPath: 'marketconfiguration',
          hideCaseBar: true,
          b2dRoles: ['awp_b2d_marketadmin', 'awp_b2d_marketconfig']
        },
        {
          titleResource: 'apps.editingAudit',
          icon: 'table_search',
          webComponentUrls: {
            b2d: '/api/gui/leads/cockpit/main.mjs',
            b2dIntranet: '/api/gui/leads/cockpit/main.mjs'
          },
          webComponentCustomTag: 'leads-cockpit-editing-audit',
          routingPath: 'editingaudit',
          hideCaseBar: true,
          b2dRoles: ['awp_b2d_editing_audit']
        },
        {
          titleResource: 'Technipedia',
          icon: 'book',
          iFrameUrls: {
            b2d: 'https://technipedia-int.bmwgroup.com',
            b2dIntranet: 'https://technipedia-int.bmwgroup.net'
          },
          b2dRoles: ['dokunext_user_read'],
          routingPath: 'technipedia',
          hideCaseBar: true
        }
      ]
    }
  ],
  urls: {
    airServices: {
      b2d: 'https://air-services-b2d-qa2-wen-oidc.bmwgroup.com/ui',
      b2dIntranet: 'https://air-services-internal-qa2.bmwgroup.net/ui'
    },
    pairBaseUrl: {
      b2d: 'https://air-services-b2d-int-wen-oidc.bmwgroup.com',
      b2dIntranet: 'https://air-services-b2d-int-wen-oidc.bmwgroup.com'
    },
    keypool: {
      b2d: 'https://ckf-qa.bmwgroup.com',
      b2dIntranet: 'https://ckf-qa.bmwgroup.net'
    },
    mileageService: {
      b2d: 'https://ckf-int.bmwgroup.com',
      b2dIntranet: 'https://ckf-int.bmwgroup.net'
    },
    servicePlanning: {
      b2d: 'https://ckf-int.bmwgroup.com',
      b2dIntranet: 'https://ckf-int.bmwgroup.net'
    },
    checkControlMessage: {
      b2d: 'https://ckf-int.bmwgroup.com',
      b2dIntranet: 'https://ckf-int.bmwgroup.net'
    },
    dealerCockpit: {
      b2d: 'https://dealercockpit2-e2e.bmwgroup.com',
      b2dIntranet: 'https://dealercockpit2-e2e.bmwgroup.net'
    },
    faultCodes: {
      b2d: 'https://ckf-int.bmwgroup.com',
      b2dIntranet: 'https://ckf-int.bmwgroup.net'
    },
    cosy: {
      b2d: 'https://int.cosy.bmw.cloud/AWP/cosySec?',
      b2dIntranet: 'https://cosy-internal-int.bmwgroup.net/AWP/cosySec?'
    },
    etkConfig: {
      b2d: 'https://etk-cloud-eu-int.bmwgroup.com',
      b2dIntranet: 'https://etk-cloud-eu-int.bmwgroup.net'
    },
    los: {
      b2d: 'https://c2b-services-i.bmw.com',
      b2dIntranet: 'https://c2b-services-i.bmw.com'
    },
    printDataConfigurator: {
      b2d: 'https://pdc-ui.awp-print-dev.aws.bmw.cloud',
      b2dIntranet: 'https://pdc-ui.awp-print-dev.aws.bmw.cloud'
    },
    updateService: {
      b2d: '/api/update/client/versions?hub=emea&realm=internet',
      b2dIntranet: '/api/update/client/versions?hub=emea&realm=intranet'
    },
    remoteKeyRead: {
      b2d: 'https://ckf-int.bmwgroup.com',
      b2dIntranet: 'https://ckf-int.bmwgroup.net'
    },
    carsServices: {
      b2d: 'https://catalog-research-int.aws.bmw.cloud',
      b2dIntranet: 'https://catalog-research-int.eu-central-1.aws.cloud.bmw'
    },
    esa: {
      b2d: 'https://esa1-us-e2e.bmwgroup.com/esa/#',
      b2dIntranet: 'https://esa1-us-e2e.bmwgroup.net/esa/#'
    },
    sccAppointmentsService: {
      b2d: 'https://api.scc-apps-qa.aws.bmw.cloud/appt',
      b2dIntranet: 'https://api.scc-apps-qa.eu-central-1.aws.cloud.bmw/appt'
    },
    editMileage: {
      b2d: 'https://ckf-int.bmwgroup.com',
      b2dIntranet: 'https://ckf-int.bmwgroup.net'
    },
    customerData: {
      b2d: 'https://cdf-test.rspretailcrm.com',
      b2dIntranet: 'https://cdf-test.ext.eu-central-1.aws.cloud.bmw'
    },
    acs: {
      b2d: 'https://api.cute-apps-qa.aws.bmw.cloud',
      b2dIntranet: 'https://internal.cute-apps-qa.eu-central-1.aws.cloud.bmw'
    },
    tsara: {
      b2d: 'https://tsara-uat-b2d.bmwgroup.com',
      b2dIntranet: 'https://tsara-uat-b2d.bmwgroup.net'
    },
    serviceContracts: {
      b2d: 'https://air-services-b2d-int-wen-oidc.bmwgroup.com',
      b2dIntranet: 'https://air-services-b2d-int-wen-oidc.bmwgroup.com'
    },
    appointmentService: {
      b2d: 'https://cluster-ingress.awp-appointment-qa.aws.bmw.cloud',
      b2dIntranet: 'https://cluster-ingress.awp-appointment-qa.aws.bmw.cloud'
    },
    softPlanning: {
      b2d: 'https://api.soft-nrg.com',
      b2dIntranet: 'https://api.soft-nrg.com'
    }
  }
};
